import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import {
  DEFAULT_LANGUAGE,
  AVAILABLE_LANGUAGES
} from 'pages/create-activity/constants';

import {
  Input,
  MultipleSelectField,
  RadioButtonsGroup,
  FormActionButtons,
  DndUploadImage,
  PopoverWrapper
} from 'components';

import HelpIcon from '@material-ui/icons/Help';

import validate from './validate';

import { useStyles } from './styles';
import DeactivateDatesInput from '../deactivate-dates-input';

const initialValues = {
  activityType: 'Open',
  productCode: ''
};

const GeneralCreate = ({
  handleSubmit,
  isUpdate,
  setSubmitButton,
  bookDates,
  ...otherProps
}) => {
  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;
  const [t] = useTranslation();

  const classes = useStyles();
  const availableLanguages = [...AVAILABLE_LANGUAGES].filter(
    x => !languages.includes(x)
  );

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('General')}
      </Typography>
      <MultipleSelectField
        availableItems={availableLanguages}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
      />
      <form onSubmit={handleSubmit}>
        <div className={classes.row}>
          <div className={classes.column}>
            <Field
              className={classes.inputIndent}
              name="coverPhoto"
              label="Cover photo *"
              component={DndUploadImage}
            />
          </div>
          <div className={classes.column}>
            <Field
              name="title"
              placeholder="Title"
              className={classes.inputIndent}
              label="Title *"
              component={Input}
            />
            {isUpdate && (
              <Field
                name="productCode"
                disabled
                placeholder="Product code"
                className={classes.inputIndent}
                label="Product code"
                component={Input}
              />
            )}
            <div className={classes.activityTypeWrapper}>
              <Field
                name="activityType"
                label={'Activity type'}
                list={['Open', 'Private']}
                component={RadioButtonsGroup}
              />

              <PopoverWrapper text="Activity type info sign">
                <HelpIcon className={classes.helpIcon} />
              </PopoverWrapper>
            </div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.column}>
            <Field
              name="minParticipants"
              isOnlyNumber={true}
              maxLength={9}
              placeholder="Number of Participants"
              className={classes.inputIndent}
              label="Min. number of participants *"
              component={Input}
            />
          </div>
          <div className={classes.column}>
            <Field
              name="maxParticipants"
              isOnlyNumber={true}
              maxLength={9}
              placeholder="Number of Participants"
              className={classes.inputIndent}
              label="Max. number of participants *"
              component={Input}
            />
          </div>
        </div>
        <Field
          name="startingPoint"
          placeholder="Starting point"
          className={classes.inputIndent}
          label="Starting point *"
          component={Input}
        />

        <div className={classes.row} style={{ marginBottom: 30 }}>
          <Field
            name="deactivatedDates"
            label="Deactivated Days"
            component={DeactivateDatesInput}
            bookDates={bookDates}
          />
        </div>
       
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'generalForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(GeneralCreate);
